<template>
	<div class="video-content">
		<div class="header-inner container-fluid clearfix">
			<div class="top">
				<div class="logo">
					<a href="/index.html" title="回到首页"><img src="@/assets/img/logo.png"><span>码速编程网</span></a>
				</div>
				<div class="desc">
					<p>{{teachChapter.chapterName}}</p>
				</div>
				<div id="uploadify-nav" class="nav">
					<a class="btn btn-danger l-btn-3" id="chapterTask">课件下载</a>
				</div>
				<div class="login-center mt-2">
					<a v-if="!isLogin" class="login-center__a" href="javascript:void(0)"><span class="fa fa-user-circle-o" aria-hidden="true"> <i>登录</i></span></a>
					<a v-else @mouseover="onOver" @mouseout="onOut"><img class="header__img rounded-circle" :src="sessionInfo.headimgurl">
						<div class="u-panel" v-show="isShow"><em style="right: 18px;"></em>
							<div class="content">
								<div class="u-info">
									<div class="u-pic"><img class="rounded-circle" :src="sessionInfo.headimgurl"></div>
									<div class="u-username">{{sessionInfo.wxNickName}}</div>
									<div class="u-rolename"><span class="badge badge-primary badge__1">{{sessionInfo.roleInfo.roleName}}</span></div>
								</div>
								<div class="u-bottom">
									<a v-if="sessionInfo.roleInfo.id == 3 || sessionInfo.roleInfo.id == 4" href="/itmswcn/maintain/main.html">进入后台中心</a>
									<a v-else href="#">进入个人中心</a>
									<a href="javascript:void(0)" @click="logout">退出登录</a>
								</div>
							</div>
						</div>
					</a>
				</div>
			</div>
		</div>
		<div class="container-inner container-fluid clearfix">
			<div class="left" style="height: 661.024px;">
				<div class="video-wrapper">
				</div>
			</div>
			<div class="right scroll_wrap" style="height: 659.024px;">
				<div class="panel-top">
					<h2>章节列表</h2>
				</div>
				<div class="section-list">
					<div class="section-item section-item-0 active">
						<div class="item-img"><img src="/common/images/v-box.jpg">
							<div class="item-label"><label>9:57</label></div>
						</div>
						<div class="item-desc">
							<h3>1.1 HTML5文档结构</h3>
							<p>1177次播放</p>
						</div>
					</div>
					<div class="section-item section-item-1">
						<div class="item-img"><img src="/common/images/v-box.jpg">
							<div class="item-label"><label>10:16</label></div>
						</div>
						<div class="item-desc">
							<h3>1.2 CSS使用方式</h3>
							<p>219次播放</p>
						</div>
					</div>
					<div class="section-item section-item-2">
						<div class="item-img"><img src="/common/images/v-box.jpg">
							<div class="item-label"><label>9:44</label></div>
						</div>
						<div class="item-desc">
							<h3>1.3 超链接标签</h3>
							<p>161次播放</p>
						</div>
					</div>
					<div class="section-item section-item-3">
						<div class="item-img"><img src="/common/images/v-box.jpg">
							<div class="item-label"><label>9:40</label></div>
						</div>
						<div class="item-desc">
							<h3>1.4 超链接样式</h3>
							<p>125次播放</p>
						</div>
					</div>
					<div class="section-item section-item-4">
						<div class="item-img"><img src="/common/images/v-box.jpg">
							<div class="item-label"><label>9:41</label></div>
						</div>
						<div class="item-desc">
							<h3>1.5 列表标签</h3>
							<p>96次播放</p>
						</div>
					</div>
					<div class="section-item section-item-5">
						<div class="item-img"><img src="/common/images/v-box.jpg">
							<div class="item-label"><label>9:46</label></div>
						</div>
						<div class="item-desc">
							<h3>1.6 列表样式</h3>
							<p>94次播放</p>
						</div>
					</div>
					<div class="section-item section-item-6">
						<div class="item-img"><img src="/common/images/v-box.jpg">
							<div class="item-label"><label>9:49</label></div>
						</div>
						<div class="item-desc">
							<h3>1.7 表格布局菜单</h3>
							<p>90次播放</p>
						</div>
					</div>
					<div class="section-item section-item-7">
						<div class="item-img"><img src="/common/images/v-box.jpg">
							<div class="item-label"><label>9:59</label></div>
						</div>
						<div class="item-desc">
							<h3>1.8 完善京东导航菜单</h3>
							<p>145次播放</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		name: 'TeachVideoContent',
		props: ["teachChapter"],
		data() {
			return {
				sessionInfo: "",
				isLogin: false,
				isShow: false,
				teachSubject: []
			}
		},
		methods: {
			onOver() {
				this.isShow = true
			},
			onOut() {
				this.isShow = false
			},
			getSessionInfo() {
				axios.get('/itmswcn/user/session')
					.then(this.getSessionInfoSucc)
			},
			getSessionInfoSucc(res) {
				res = res.data
				if(res.code == 100) {
					this.isLogin = true
					this.sessionInfo = res.data
				} else {
					this.isLogin = false
				}
				this.$store.commit('setLoginFlag', this.isLogin)
			},
			logout() {
				$.confirm({
					title: '',
					content: '<span class="itmsw_ft_1"><i class="fa fa-check-square-o"></i> 您确定要退出码速编程网吗？</span>',
					theme: 'modern',
					closeIcon: false,
					animation: 'scale',
					type: 'blue',
					boxWidth: '380px',
					useBootstrap: false,
					backgroundDismiss: false,
					buttons: {
						yes: {
							text: '确认', // text for button
							btnClass: 'itmsw_bt_confirm_1', // class for the button
							keys: ['y'], // keyboard event for button
							isHidden: false, // initially not hidden
							isDisabled: false, // initially not disabled
							action: function(yesButton) {
								axios.get('/itmswcn/common/util/logout')
									.then(function(res) {
										if(res.data.code == 100) {
											window.location = "/";
										}
									});
							}
						},
						no: {
							text: '取消', // text for button
							btnClass: 'itmsw_bt_confirm_2', // class for the button
							keys: ['n'], // keyboard event for button
							isHidden: false, // initially not hidden
							isDisabled: false, // initially not disabled
							action: function(noButton) {}
						}
					}
				});
			}
		},
		mounted() {
			this.getSessionInfo()
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/teach/components/TeachVideoContent.scss';
</style>